/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownCentralPartner } from '../models/db_DropdownCentralPartner';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CentralPartners {
    /**
     * Get a list of central partners
     * @returns db_DropdownCentralPartner OK
     * @throws ApiError
     */
    public static listCentralPartners(): CancelablePromise<Array<db_DropdownCentralPartner>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/central-partners',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
